import { Link } from "react-router-dom";

const buttonMsg = {
  kitchens: "Descubra a cozinha",
  closets: "Descubra o roupeiro",
};

const Item = ({ item, reverse, type }) => (
  <div
    className={`h-80 flex mt-5 ${reverse ? "flex-row-reverse" : "flex-row"}`}
  >
    <div className="w-1/2 overflow-hidden flex">
      <img src={item.highlight} alt="" className="object-cover w-full" />
    </div>
    <div className="w-1/2 flex flex-col justify-center items-center p-10">
      <h2 class="mb-4 text-4xl font-bold font-oswald">{item.name}</h2>
      <p className="text-base mb-8 text-center whitespace-pre-line">
        {Array.isArray(item.description)
          ? item.description[0]
          : item.description}
      </p>
      <Link to={`/${type}/${item.id}`}>
        <button
          type="button"
          //class="inline-block rounded bg-primary px-6 pt-2.5 pb-2 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
          className="inline-block px-7 py-3 bg-gray-400 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-gray-800 hover:shadow-lg focus:bg-gray-800 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out mb-2 md:mr-2"
        >
          {buttonMsg[type]}
        </button>
      </Link>
    </div>
  </div>
);

const List = ({ list, type = "kitchens" }) => (
  <div className="pb-5">
    {!list || list.length === 0 ? (
      <div className="flex justify-center items-center h-screen font-black text-3xl">
        No elements!
      </div>
    ) : (
      list.map((item, index) => (
        <Item item={item} reverse={!(index % 2 === 0)} type={type} />
      ))
    )}
  </div>
);

export default List;
